module.exports = __webpack_public_path__ + "img/Background_FSCdeskartemis.1b446db4.png";